import React from 'react';

import { useIntl } from 'react-intl';

import { VisuallyHidden } from 'components/ucl/visually-hidden';

/**
 * Opens the link in a new tab.
 */
export const ExternalLink: React.FC<React.PropsWithChildren<React.AnchorHTMLAttributes<{}>>> = ({
  children,
  ...props
}) => {
  const { formatMessage } = useIntl();

  return (
    <ExternalLinkView
      dataSet={undefined}
      {...props}
      accessibilityText={formatMessage({ id: 'linkOpensInNewTab' })}
    >
      {children}
    </ExternalLinkView>
  );
};

interface ExternalLinkViewProps extends React.AnchorHTMLAttributes<{}> {
  accessibilityText?: string;
  dataSet: any;
}

export const ExternalLinkView: React.FC<React.PropsWithChildren<ExternalLinkViewProps>> = ({
  children,
  accessibilityText,
  dataSet, // exclude this since it causes issues on web
  ...props
}) => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {children}
    {!!accessibilityText && <VisuallyHidden accessibilityLabel={accessibilityText} />}
  </a>
);

export default ExternalLink;
